import React, { memo, ReactNode } from 'react';

import IconComponent from '../IconComponent';
import { InformationContainer, Title, TitleContainer } from './styled';

type Props = {
  isEditable?: boolean;
  title: string;
  children: ReactNode;
  onEditClick?: () => void;
  dataTestId?: string;
  tooltip?: string;
};

const InformationPanel = ({
  isEditable = false,
  onEditClick,
  title,
  children,
  dataTestId,
  tooltip,
}: Props): JSX.Element => {
  return (
    <div data-testid={dataTestId}>
      <TitleContainer>
        <Title $isEditable={isEditable}>{title}</Title>
        {isEditable && (
          <IconComponent
            id={tooltip}
            dataTestId="informationPanelEditIcon"
            icon={{
              name: 'Edit',
              tooltip: `Edit ${tooltip}`,
            }}
            onClick={onEditClick}
          />
        )}
      </TitleContainer>
      <InformationContainer>{children}</InformationContainer>
    </div>
  );
};

export default memo(InformationPanel);
